"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiEventsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const LinkEntity_1 = require("../../common/model/LinkEntity");
class ApiEventsClient extends ApiSubClient_1.ApiSubClient {
    trackSearchQueryCompletionsSuggested(request) {
        const trackSearchQueryCompletionsSuggestedLink = this.getLinkOrThrow('createSearchQueryCompletionsSuggestedEvent');
        return this.axios.post(trackSearchQueryCompletionsSuggestedLink.href, request, this.getHeaderWithReferer());
    }
    trackPageRendered(request) {
        const trackPageRenderedLink = this.getLinkOrThrow('trackPageRendered');
        request = {
            ...request,
            viewport: request.viewport || this.getViewport(),
        };
        return this.axios.post(trackPageRenderedLink.href, request);
    }
    trackCollectionInteraction(collection, request, referer = null) {
        const validInteractionLink = collection && collection.links.interactedWith;
        if (!validInteractionLink) {
            throw new Error('Collection interaction link not available');
        }
        return this.axios.post(validInteractionLink.getOriginalLink(), request, {
            headers: { 'Boclips-Referer': referer },
        });
    }
    trackUserExpired() {
        const trackPageRenderedLink = this.getLink('reportAccessExpired');
        if (!trackPageRenderedLink) {
            return Promise.resolve();
        }
        return this.axios.post(trackPageRenderedLink.href);
    }
    trackPlatformInteraction(subtype, anonymous) {
        const trackLinkEntity = this.getLinkOrThrow('trackPlatformInteractedWith');
        const expandedLink = new LinkEntity_1.Link({
            href: trackLinkEntity.href,
            templated: trackLinkEntity.templated,
        }).getTemplatedLink({ subtype, anonymous });
        return this.axios.post(expandedLink, {}, this.getHeaderWithReferer());
    }
    trackVideoInteraction(video, subtype) {
        return this.axios.post(video.links.logInteraction.getTemplatedLink({ type: subtype }), {}, this.getHeaderWithReferer());
    }
    getHeaderWithReferer() {
        return {
            headers: { 'Boclips-Referer': window.location.href },
        };
    }
    getViewport() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }
}
exports.ApiEventsClient = ApiEventsClient;
//# sourceMappingURL=ApiEventsClient.js.map